import { Col, Container, Row } from 'react-bootstrap';
import {
  AttachmentsLinks,
  Card,
} from './styles';
import edit from '../../../../../assets/images/icons/edit.svg';
import { MappedProgramType, ProgramBeingEditedType  } from '../../types';
import OpacityAnimation from '../../../../../components/OpacityAnimation';
import { getFilenameFromUrl } from '../../utils/attachments';

interface ListInterface {
  filteredList: MappedProgramType[];
  onOpenEditModal: ({ id, specificProgram, date, startTime, endTime, attachments }: ProgramBeingEditedType) => void;
}

export default function List({
  filteredList,
  onOpenEditModal,
}: ListInterface) {
  return (
    <Container>
      <Row xs={1} md={2} lg={3}>
        {filteredList?.map((program) => (
          <Col key={program.id}>
            <OpacityAnimation delay={0.1}>
              <Card title="Expandir detalhes">
                <div className="info">
                  <div className="card-title">
                    <strong>{program.date}</strong>

                    <small className={program.status === 'approved' ? 'green' : 'orange'}>
                      {program.status === 'approved' ? 'Aprovado' : 'Requer revisão'}
                    </small>
                  </div>
                  <span>
                    Horário:
                    {' '}
                    {program.startTime} - {program.endTime}
                  </span>
                  {program.attachments.length > 0 && (
                    <AttachmentsLinks>
                      {program.attachments.map((url) => (
                        <a
                          key={url}
                          href={url}
                          target="_blank"
                          rel="noreferrer"
                          title={getFilenameFromUrl(url)}
                        >
                          {getFilenameFromUrl(url)}
                        </a>
                      ))}
                    </AttachmentsLinks>
                  )}
                </div>
                <div className="actions">
                  <button
                    type="button"
                    onClick={() => onOpenEditModal(program)}
                  >
                    <img src={edit} alt="" title={`Editar programção de ${program.date} | ${program.startTime} - ${program.endTime}`} className='primaryColor' />
                  </button>
                </div>
              </Card>
            </OpacityAnimation>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
